// @unocss-include
const layout = () => import('@/layout/index.vue')
const routes = [
  {
    path: '/trend',
    name: 'Trend',
    component: layout,
    redirect: '/trend/index',
    meta: {
      title: '趋势分析',
      icon: 'i-menu:trend',
      i18Key: 'router.user.trend.title',
      roles: [1]
    },
    sort: 10,
    children: [
      {
        path: 'index',
        name: 'TrendIndex',
        component: () => import('@/views/Trend/Index.vue'),
        meta: {
          title: '趋势分析',
          icon: 'i-menu:trend',
          i18Key: 'router.user.trend.index',
          roles: [1],
          headerConditions: ['brand', 'timeBtn', 'questionBtn']
        }
      }
    ]
  }
]
export default routes
